import { render, staticRenderFns } from "./onlyLoginLayout.vue?vue&type=template&id=9c194b0e&"
import script from "./onlyLoginLayout.vue?vue&type=script&lang=js&"
export * from "./onlyLoginLayout.vue?vue&type=script&lang=js&"
import style0 from "./onlyLoginLayout.vue?vue&type=style&index=0&id=9c194b0e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports